"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItemIcon = exports.ListItemText = exports.StyledListItem = exports.StyledList = exports.MenuContainer = void 0;

const styled_components_1 = __importStar(require("styled-components"));

const appear = (0, styled_components_1.keyframes)`
  from {
    transform: scale(0);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
`;
const disappear = (0, styled_components_1.keyframes)`
from {
  transform: scale(1);
  opacity: 1;

}

to {
  transform: scale(0);
  opacity: 0;

}`;
exports.MenuContainer = styled_components_1.default.div`
  position: absolute;
  max-width: 300px;
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
  ${props => props.coordinates};
  ${props => {
  if (props.position === 'top') {
    return (0, styled_components_1.css)`
        transform: translate(-100%, -100%);
      `;
  }

  if (props.position === 'right') {
    return (0, styled_components_1.css)`
        transform: translate(0, 0);
      `;
  }

  return (0, styled_components_1.css)`
      transform: translate(-100%, 0);
    `;
}}
`;
exports.StyledList = styled_components_1.default.ul`
  background-color: ${props => props.theme.colors.white};
  list-style: none;
  margin: 0;
  padding: 0;
  border-radius: 5px;
  box-shadow: 0px 2px 10px #00000033;
  transition: transform 0.2s;
  animation: 0.2s ease-in forwards;
  border-radius: 5px;
  padding: 6px 0;
  ${props => props.isOpen ? (0, styled_components_1.css)`
          animation-name: ${appear};
        ` : (0, styled_components_1.css)`
          animation-name: ${disappear};
        `}

  ${props => {
  if (props.position === 'top') {
    return (0, styled_components_1.css)`
        margin-bottom: 9px;
        transform-origin: bottom right;
      `;
  }

  if (props.position === 'right') {
    return (0, styled_components_1.css)`
        margin-left: 9px;
        transform-origin: top left;
      `;
  }

  if (props.position === 'bottom') {
    return (0, styled_components_1.css)`
        margin-top: 9px;
        transform-origin: top right;
      `;
  }

  if (props.position === 'left') {
    return (0, styled_components_1.css)`
        margin-right: 9px;
        transform-origin: top right;
      `;
  }
}}

  ${props => props.stylesOverride};
`;
exports.StyledListItem = styled_components_1.default.li`
  padding: 6px 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${props => props.theme.colors.gray_602};
  user-select: none;
  min-width: 120px;
  &:hover {
    background: ${props => props.theme.colors.primary_700_main + '0d'};
  }

  ${props => props.size === 's' && (0, styled_components_1.css)`
      padding: 0;
    `}

  ${props => props.size === 'm' && (0, styled_components_1.css)`
      padding: 6px 15px;
    `}
  ${props => props.size === 'l' && (0, styled_components_1.css)`
      padding: 10px 15px;
    `}

  ${props => props.stylesOverride};
`;
exports.ListItemText = styled_components_1.default.span`
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: ${props => props.theme.fontSizes[14]};
  line-height: ${props => props.theme.lineHeights[18]};
`;
exports.ListItemIcon = styled_components_1.default.div`
  display: flex;
  align-items: center;
  margin-right: 10px;
`;